import { ClaimIntegrationDto, ClaimIntegrationControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  claimIntegration: ClaimIntegrationDto;
  xTENANTID?: string;
}

export const useAddClaimIntegration = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimIntegrationControllerApi(getConfigObject()).addConfiguration1(
      params.claimIntegration,
      params.xTENANTID
    )
  );
